import {CandidatePoiItem, UserActivityCategoryEnum} from '@mobi-components/global-solution';
import {computed} from '@vue/composition-api';
import {useStay} from '../../solution-views/stay';
import {getManualActivities} from '@/store/state/helpers';
import {getCandidatePoiItem} from '../../solution-views/explore-view/group-management';

export const useSavedPlaces = () => {
  const {solution} = useStay();

  const includedSolutionActivities = computed<CandidatePoiItem[]>(() => {
    return (solution.value?.activities || [])
      .filter((x) => [UserActivityCategoryEnum.EXPERIENCE, UserActivityCategoryEnum.DINING].includes(x.category))
      .filter((x) => x.spec?.curated === false)
      .filter((x) => x.source?.content)
      .map((x) => x.source.content)
      .filter(Boolean) as CandidatePoiItem[];
  });

  const manualActivities = computed(getManualActivities);

  const savedPois = computed<CandidatePoiItem[]>(() => {
    return (solution.value?.dropped_activities || [])
      .filter((x) => x.candidate_information?.candidates?.length || x.candidate_information?.selection)
      .map((x) => getCandidatePoiItem(x.candidate_information))
      .concat(includedSolutionActivities.value)
      .concat(manualActivities.value);
  });

  const savedPoiIds = computed(() => {
    return new Set(savedPois.value.map((x) => x.id));
  });

  return {
    manualActivities,
    savedPois,
    savedPoiIds,
  };
};
